import { createSlice } from '@reduxjs/toolkit';

import { STATUS_TYPES } from '../../constants';
import initialState from './initialState';

const loadSummarySlice = createSlice({
  name: 'loadSummary',
  initialState,
  reducers: {
    loadSummaryFetching(state) {
      state.status = STATUS_TYPES.INIT_STATE;
    },
    loadSummarySucceeded(state, { payload }) {
      state.status = STATUS_TYPES.SUCCEED_STATE;
      state.data = payload;
    },
    loadSummaryFailed(state, { payload }) {
      state.status = STATUS_TYPES.FAILED_STATE;
      state.error = {
        status: payload?.status,
        message: payload?.message,
      };
    },
    updateLoadSummary(state, { payload }) {
      state.data = {
        ...state.data,
        ...payload,
      };
    },
    clearLoadSummary() {
      return initialState;
    },
  },
});

export const {
  loadSummaryFailed,
  loadSummaryFetching,
  loadSummarySucceeded,
  updateLoadSummary,
  clearLoadSummary,
} = loadSummarySlice.actions;

export default loadSummarySlice.reducer;
